import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(value: number): string {
    const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = 0;
    while (Math.abs(value) >= 1024 && u < units.length - 1) {
      value /= 1024;
      u++;
    }
    return value.toFixed(1) + units[u];
  }

}
